import React, { Component, createRef } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

class Main extends Component {
  mainRef = createRef();

  componentDidMount() {
    window.scroll(0, 0);
    const script = document.createElement("script");
    const newFile = `${process.env.PUBLIC_URL}/assets/js/main.js`;

    script.type = "text/javascript";
    script.src = newFile;
    script.async = true;

    document.body.appendChild(script);
    var allScripts = document.getElementsByTagName("script");
    for (var i = allScripts.length; i >= 0; i--) {
      if (allScripts[i] && allScripts[i].getAttribute("src") === newFile) {
        allScripts[i].parentNode.removeChild(allScripts[i]);
        document.body.appendChild(script);
      }
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div className="canvas" ref={this.mainRef}>
        <div id="box_wrapper">
          <Header />
          {children}
          <Footer />
        </div>
      </div>
    );
  }
}

export default Main;
